import { render, staticRenderFns } from "./EquipeTarefaAssociacaoPage.vue?vue&type=template&id=7f44ea3c&scoped=true"
import script from "./EquipeTarefaAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./EquipeTarefaAssociacaoPage.vue?vue&type=script&lang=js"
import style0 from "./EquipeTarefaAssociacaoPage.vue?vue&type=style&index=0&id=7f44ea3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f44ea3c",
  null
  
)

export default component.exports